module.exports = __webpack_public_path__ + "static/media/Polka-dots-NYC-SS18.9e934ee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fabrics-prints/Polka-dots-NYC-SS18.jpg
// module id = 167
// module chunks = 0